export { default } from 'choerodon-ui/dataset/validator/rules/customError';
